import { render } from "./ClinicalResearch.vue?vue&type=template&id=27de9d36"
import script from "./ClinicalResearch.vue?vue&type=script&lang=js"
export * from "./ClinicalResearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__